// src/components/CostConfirmationModal.js
import React from 'react';
import ReactDOM from 'react-dom';
import { AlertTriangle, DollarSign } from 'lucide-react';
import './CostConfirmationModal.css';

const CostConfirmationModal = ({ cost, onConfirm, onCancel }) => {
  const modalContent = (
    <div className="cost-modal-overlay" onClick={onCancel}>
      <div className="cost-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cost-modal-header">
          <AlertTriangle size={24} className="warning-icon" />
          <h3>High Cost Warning</h3>
        </div>
        
        <div className="cost-modal-content">
          <p>This message will cost approximately:</p>
          <div className="cost-amount">
            <DollarSign size={20} />
            <span>${cost.toFixed(4)}</span>
          </div>
          <p>Are you sure you want to continue?</p>
        </div>
        
        <div className="cost-modal-actions">
          <button onClick={onCancel} className="cancel-btn">
            Cancel
          </button>
          <button onClick={onConfirm} className="confirm-btn">
            Send Anyway
          </button>
        </div>
      </div>
    </div>
  );
  
  return ReactDOM.createPortal(modalContent, document.body);
};

export default CostConfirmationModal;